/**
 * /admin — the superadmin CRM, route-guarded.
 *
 * The CRM used to live at the root. It moved here so the root could become the
 * commercial toolkit's front door (World 1), leaving ARC and the CRM reachable
 * only by their own addresses.
 *
 * A non-superadmin who finds this URL gets the TOOLKIT sign-in, never ARC's —
 * that is the whole point of the two-worlds split. We render the toolkit home
 * in place rather than redirecting, so the address bar doesn't advertise that
 * /admin exists or that they were refused.
 *
 * The guard waits for `isLoading` to settle. Deciding on a half-loaded auth
 * state would bounce a genuine superadmin on every cold load, because claims
 * arrive after the user object does.
 */
import React from 'react';
import { useAuth } from '../context/AuthContext';
import useDocumentTitle from '../lib/useDocumentTitle';
import ToolkitHome from '../toolkit/ToolkitHome';
import App from '../App';

export default function AdminRoute() {
  const { isLoading, isSuperadmin } = useAuth();

  useDocumentTitle(isSuperadmin ? 'Admin' : null);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-teal-600" />
      </div>
    );
  }

  if (!isSuperadmin) return <ToolkitHome />;

  return <App />;
}
